import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { LocationsBulkEffects } from './bulk-actions/bulk-actions.effects';
import { LocationsBulkNamespace, LocationsBulkReducer } from './bulk-actions/bulk-actions.store';
import { LocationsByCompanyEffects } from './locations-by-company/locations-by-company.effects';
import {
  LocationsByCompanyNamespace,
  LocationsByCompanyReducer,
} from './locations-by-company/locations-by-company.store';
import { LocationsCountersEffects } from './locations-counters/locations-counters.effects';
import {
  LocationCountersNamespace,
  LocationCountersReducer,
} from './locations-counters/locations-counters.store';
import { LocationsJobsEffects } from './locations-jobs/locations-jobs.effects';
import { LocationJobsNamespace, LocationJobsReducer } from './locations-jobs/locations-jobs.store';
import { LocationsTranslationCountersEffects } from './locations-translation-counters/locations-translation-counters.effects';
import {
  LocationTranslationCountersNamespace,
  LocationTranslationCountersReducer,
} from './locations-translation-counters/locations-translation-counters.store';
import { LocationsEffects } from './locations/locations.effects';
import { LocationNamespace, LocationReducer } from './locations/locations.store';

@NgModule({
  imports: [
    StoreModule.forFeature(LocationNamespace, LocationReducer),
    StoreModule.forFeature(LocationCountersNamespace, LocationCountersReducer),
    StoreModule.forFeature(LocationsByCompanyNamespace, LocationsByCompanyReducer),
    StoreModule.forFeature(
      LocationTranslationCountersNamespace,
      LocationTranslationCountersReducer,
    ),
    StoreModule.forFeature(LocationJobsNamespace, LocationJobsReducer),
    StoreModule.forFeature(LocationsBulkNamespace, LocationsBulkReducer),
    EffectsModule.forFeature([
      LocationsEffects,
      LocationsCountersEffects,
      LocationsTranslationCountersEffects,
      LocationsJobsEffects,
      LocationsByCompanyEffects,
      LocationsBulkEffects,
    ]),
  ],
})
export class LocationsDataModule {}
